import React, { useEffect, useState } from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from 'recharts';
import baseURL from '../../url';

const MESES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

export default function PedidosEntregadosConTotal() {
    const [data, setData] = useState([]);
    const [totalPedidos, setTotalPedidos] = useState(0);

    useEffect(() => {
        async function fetchPedidos() {
            try {
                const res = await fetch(`${baseURL}/pedidoGet.php`);
                const json = await res.json();

                if (json && Array.isArray(json.pedidos)) {
                    const pedidos = json.pedidos;

                    setTotalPedidos(pedidos.length);

                    // Inicializa los meses con total 0
                    const pedidosPorMes = MESES.map(mes => ({ mes, total: 0 }));

                    pedidos.forEach(({ createdAt, fecha }) => {
                        // Usa createdAt o fecha, según disponibilidad
                        const fechaPedido = new Date(createdAt || fecha);
                        if (!isNaN(fechaPedido)) {
                            pedidosPorMes[fechaPedido.getMonth()].total += 1;
                        }
                    });

                    setData(pedidosPorMes);
                } else {
                    setTotalPedidos(0);
                    setData(MESES.map(mes => ({ mes, total: 0 })));
                }
            } catch (error) {
                console.error('Error cargando pedidos:', error);
                setTotalPedidos(0);
                setData(MESES.map(mes => ({ mes, total: 0 })));
            }
        }
        fetchPedidos();
    }, []);

    // Formatear número con separadores de miles
    const formatoNumero = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return (
        <div style={{ width: '100%', marginTop: '20px' }}>
            <h3 style={{ textAlign: 'center' }}>📦 Pedidos ingresados por mes</h3>

            <div style={{ width: '100%', height: 350 }}>
                <ResponsiveContainer>
                    <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="mes" />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Line type="monotone" dataKey="total" stroke="#8884d8" strokeWidth={3} />
                    </LineChart>
                </ResponsiveContainer>
            </div>

            <h3 style={{ textAlign: 'center', marginTop: '40px' }}>
                📋 Total de pedidos ingresados: {formatoNumero(totalPedidos)}
            </h3>
        </div>
    );
}
